import { useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useTranslation } from "../../context/TranslationContext";

const FAQ = () => {
    const { translateSync } = useTranslation();

    useEffect(() => {
        AOS.init({ duration: 1000, once: false, mirror: true });
        window.scrollTo(0, 0);
    }, []);

    const faqItems = [
        {
            q: "Where are you located? Do you ship to Singapore?",
            a: "We are an online boutique specializing in authentic Indian handloom silk sarees. Our primary market is Singapore, and we deliver packages securely to buyers across Singapore. We also ship across India."
        },
        {
            q: "Are the sarees authentic handloom silk?",
            a: "Yes! All silk sarees in our catalog are handpicked directly from traditional master weavers across India. We source authentic Kanchi Korvai Pattu, Uppada, and classic silk weaves, ensuring genuine quality."
        },
        {
            q: "How long does shipping take?",
            a: "For local Singapore orders, standard delivery takes 2-3 business days after dispatch. Orders in India take 3-5 business days. International orders typically arrive in 5-10 business days."
        },
        {
            q: "Do you offer blouse stitching or custom tailoring?",
            a: "Currently, our sarees are shipped unstitched with the running blouse material. However, we can assist with custom falls, edging, and blouse tailoring suggestions. Please reach out to our WhatsApp customer support team after placing your order to inquire."
        },
        {
            q: "What is your return policy?",
            a: "We offer exchanges or store credit for unused, unstitched sarees returned in their original packaging within 7 days of delivery. Custom-tailored products, sale items, and sarees with custom edging or falls are not eligible for returns."
        }
    ];

    const faqSchema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqItems.map(item => ({
            "@type": "Question",
            "name": item.q,
            "acceptedAnswer": {
                "@type": "Answer",
                "text": item.a
            }
        }))
    };

    return (
        <>
            <Helmet>
                <title>FAQ | Colours Boutique Saree Shopping Questions</title>
                <meta name="description" content="Find answers to common Colours Boutique questions about saree orders, Singapore delivery, returns, and care instructions." />
                <link rel="canonical" href="https://coloursboutique.com/faq" />
                <script type="application/ld+json">
                    {JSON.stringify(faqSchema)}
                </script>
            </Helmet>

            <div className="home-saree-container">
                <section className="about-header-section text-center" style={{ paddingTop: "150px", paddingBottom: "20px" }}>
                    <div className="container">
                        <h1 className="fw-bold display-5 font-51" style={{ color: "#3a3530" }}>{translateSync('Frequently Asked Questions')}</h1>
                        <nav aria-label="breadcrumb" className="boutique-breadcrumb-nav center-align">
                            <ol className="boutique-breadcrumb-ol boutique-breadcrumb-center">
                                <li className="breadcrumb-item"><span onClick={() => window.location.href = "/"}>{translateSync('Home')}</span></li>
                                <li className="breadcrumb-item active">{translateSync('FAQ')}</li>
                            </ol>
                        </nav>
                    </div>
                </section>

                <section className="training-transforms-section py-5 ">
                    <div className="container">
                        <div className="row align-items-stretch">
                            <div className="col-md-12 text-left justify-content-between">
                                <div className="aboutpage-content newww" >
                                    <div className="terms-content" style={{ lineHeight: '1.8' }}>
                                        {faqItems.map((item, index) => (
                                            <div key={index} className="mb-4 pb-4 border-bottom" data-aos="fade-up" data-aos-delay={200 + (index * 100)}>
                                                <h3 className="h5 fw-semibold mb-2" style={{ color: '#3a3530' }}>
                                                    Q: {translateSync(item.q)}
                                                </h3>
                                                <p className="mb-0 text-muted">
                                                    A: {translateSync(item.a)}
                                                </p>
                                            </div>
                                        ))}

                                        <div className="contact-info p-4 rounded-3 mt-5" style={{ backgroundColor: "#f9f9f9" }} data-aos="fade-up" data-aos-delay="700">
                                            <h3 className="mb-3 h5 fw-semibold" style={{ color: '#3a3530' }}>{translateSync('Still have questions?')}</h3>
                                            <p className="mb-3">{translateSync('Contact our customer service team via email or WhatsApp and we will be happy to help.')}</p>
                                            <ul className="list-unstyled mb-0">
                                                <li className="d-flex mb-2">
                                                    <span className="me-2" style={{ color: '#3a3530' }}>•</span>
                                                    <span>{translateSync('Email')}: <a href="mailto:coloursboutiqueadmin@gmail.com" className="text-decoration-none" style={{ color: "#3a3530" }}>coloursboutiqueadmin@gmail.com</a></span>
                                                </li>
                                                <li className="d-flex">
                                                    <span className="me-2" style={{ color: '#3a3530' }}>•</span>
                                                    <span>{translateSync('Phone / WhatsApp')}: +91 80562 62626</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default FAQ;
